

export const findUserLocation = (data, cityId) => {
  let cityName = [];
  let province = [];
  if (data) {
    for (let i = 0; i < data?.length; i++) {
      const result = data[i].cities.find(
        (item) => item.id === cityId
      );
      if (result) {
        cityName.push(result['name']);
        province.push({
          name: data[i]['name'],
          id: data[i]['id'],
        });
      }
    }
  }
  return {
    city: cityName?.length > 0 ? cityName[0] : null,
    province: province?.length > 0 ? province[0] : null,
  };
};

export const findCities = (provinces, provinceId) => {
  if (provinceId) {
    const item = provinces?.find((item) =>
      item.id === provinceId ? item : null
    );
    return item?.cities;
  }
};

export const provinceOptions = (data) =>
  data && data?.map((item) => ({ name: item.name, id: item.id }));


export const cityOptions = (data, id) => {
  if (id) {
    const item = data?.find((item) =>
      item.id === id ? item : null
    );
    return item?.cities;
  }
};